import { IActionResponse } from "./actionResult";

export type DrawerFormSaveResult =
    | Promise<IActionResponse | void>
    | IActionResponse
    | void;

export const hasClientErrorOperationStatusCode = (
    result: IActionResponse | void
): boolean => {
    const operationStatusCode = result?.operationStatusCode;
    return !!operationStatusCode && operationStatusCode >= 400 && operationStatusCode < 500;
};
